export default "__VITE_ASSET__CZ2TOn9q__"